import * as React from "react";
import { Card, CardContent, Box, Button, Grid } from '@mui/material';
import { Pagination, Title, List, Datagrid, TextField, RichTextField, TextInput, Edit, SimpleForm, Create, TimeInput, FunctionField, NumberInput } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import Typography from '@mui/material/Typography';
import MessageIcon from '@mui/icons-material/Message';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "./../styles/common.js";
import Stack from '@mui/material/Stack';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const variables = [
    {
        variable: "%PICKUP_DATE%",
        details: "Date et heure de prise en charge"
    },
    {
        variable: "%DELIVERY_DATE%",
        details: "Date et heure de livraison au client (départ du pressing)"
    }
]

const postFilters = [
    <TextInput label="Référence" source="reference" alwaysOn />,
    <TextInput label="Valeur" source="value" />,
    <TextInput label="Détails" source="details" />,
];

export default function VariableTable() {
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Variable</TableCell>
              <TableCell>Détails</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {variables.map((variable) => (
              <TableRow
                key={variable.variable}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {variable.variable}
                </TableCell>
                <TableCell>{variable.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

const styles = {
    subStackDiv: {
        margin: "auto"
    },
    aLink: {
        textDecoration: "none",
        margin: "16px"
    },
    input: {
        width: 600,
        margin: "auto",
        marginTop: "10px",
        marginBottom: "10px"
    }
}

export const ConfigurationMainPage = () => (
    <CardContent>
        <PageListTitle text="Page principale de configuration" />
        <Card sx={{ p: 2 }}>
            <Stack spacing={2} style={{alignItems: "center"}}>
                <a href="/#/config/message" style={styles.aLink}>
                    <Button size="large" variant="outlined" startIcon={<MessageIcon />}>
                        Configuration des messages
                    </Button>
                </a>
                <a href="/#/config/variable" style={styles.aLink}>
                    <Button size="large" variant="outlined" startIcon={<ListAltIcon />}>
                        Configuration des variables
                    </Button>
                </a>
                <a href="/#/config/timetable" style={styles.aLink}>
                    <Button size="large" variant="outlined" startIcon={<AccessTimeIcon />}>
                        Configuration des horaires
                    </Button>
                </a>
                <a href="/#/config/delivery" style={styles.aLink}>
                    <Button size="large" variant="outlined" startIcon={<LocalShippingIcon />}>
                        Configuration de la livraison
                    </Button>
                </a>
            </Stack>
        </Card>
    </CardContent>
);

export const ConfigMessageList = props => (
    <List exporter={false} {...props}  filters={postFilters} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Configuration : Liste des messages" />
        <Datagrid rowClick="edit">
            <TextField source="reference" />
            <FunctionField label="Valeur" render={record => {if(record && record.value && record.value.length > 60) {return record.value.slice(0, 60)+"..."} else {return record.value}}} />
            <TextField source="details" />
        </Datagrid>
    </List>
);

export const ConfigMessageEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Configuration : Edition du message" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} disabled source="reference" label="Référence" />
                <TextInput style={styles.input} source="details" label="Détails" />
                <TextInput multiline style={styles.input} source="value" label="Message" />
            
                <VariableTable />
            </Stack>
        </SimpleForm>
    </Edit>
);

export const ConfigMessageCreate = () => (
    <Create>
        <PageCreateTitle text="Configuration : Création d'un message" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} source="reference" label="Référence" />
                <TextInput style={styles.input} source="details" label="Détails" />
                <TextInput multiline style={styles.input} source="value" label="Message" />
            
                <VariableTable />
            </Stack>
        </SimpleForm>
    </Create>
);

export const ConfigVariableList = props => (
    <List  exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Configuration : Liste des variables" />
        <Datagrid rowClick="edit">
            <TextField source="reference" />
            <TextField source="value" />
            <TextField source="details" />
        </Datagrid>
    </List>
);

export const ConfigVariableEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Configuration : Edition d'une variable" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} disabled source="reference" label="Référence" />
                <TextInput style={styles.input} source="value" label="Valeur" />
                <TextInput style={styles.input} source="details" label="Détails" />
            </Stack>
        </SimpleForm>
    </Edit>
);

export const ConfigVariableCreate = () => (
    <Create>
        <PageCreateTitle text="Configuration : Création d'une variable" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} source="reference" label="Référence" />
                <TextInput style={styles.input} source="value" label="Valeur" />
                <TextInput style={styles.input} source="details" label="Détails" />
            </Stack>
        </SimpleForm>
    </Create>
);

export const ConfigTimetableList = props => (
    <List  exporter={false} {...props}  filters={postFilters} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Configuration : Liste des horaires" />
        <Datagrid rowClick="edit">
            <TextField source="name" label="Jour" />
            <TextField source="timetable_pickup_opening" label="Enlèvement - Ouverture" />
            <TextField source="timetable_pickup_closing" label="Enlèvement - Fermeture" />
            <TextField source="timetable_delivery_opening" label="Retour - Ouverture" />
            <TextField source="timetable_delivery_closing" label="Retour - Fermeture" />
        </Datagrid>
    </List>
);

export const ConfigTimetableEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Configuration : Edition d'un horaire" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} disabled source="name" label="Jour" />

                <span style={{textAlign: "center", margin: 0, padding: 0}}>Format : "heures:minutes" (9h30, 15h40)</span>
                
                <TextInput style={styles.input} source="timetable_pickup_opening" label="Enlèvement - Ouverture" />
                <TextInput style={styles.input} source="timetable_pickup_closing" label="Enlèvement - Fermeture" />
                <TextInput style={styles.input} source="timetable_delivery_opening" label="Retour - Ouverture" />
                <TextInput style={styles.input} source="timetable_delivery_closing" label="Retour - Fermeture" />

            </Stack>
        </SimpleForm>
    </Edit>
);

export const ConfigDeliveryList = props => (
    <List  exporter={false} {...props}  filters={postFilters} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Configuration : Prix des livraisons" />
        <Datagrid rowClick="edit">
            <TextField source="type" label="Type" />
            <TextField source="price" label="Prix (TTC)" />
            <TextField source="min_for_free" label="Minimum pour la gratuité (TTC)" />
            <TextField source="low_threshold" label="Limite pour supplément (TTC)" />
            <TextField source="low_supplement" label="Supplément (TTC)" />
        </Datagrid>
    </List>
);

export const ConfigDeliveryEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Configuration : Prix des livraisons" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={styles.input} disabled source="type" label="Type" />
                
                <NumberInput style={styles.input} source="price" label="Prix (TTC)" />
                <NumberInput style={styles.input} source="min_for_free" label="Minimum pour la gratuité (TTC)" />
                <NumberInput style={styles.input} source="low_threshold" label="Limite total commande TTC pour le supplément (dans le cas d'une petite commande)" />
                <NumberInput style={styles.input} source="low_supplement" label="Supplément pour petite commande (TTC)" />

            </Stack>
        </SimpleForm>
    </Edit>
);